// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:38.142556
var courses = [
    {
        "course_id": "88532817-0286-F111-99B9-005056A77B46",
        "course_version": 1,
        "name": "Lifebeat Solutions - Rescue Readiness Series",
        "course_type": 32,
        "author_information": "",
        "description": "Improving early recognition and timely response to patient deterioration is critical to reducing mortality rates. The Lifebeat Solutions Rescue Readiness Series is a two-course program that equips nurses with the knowledge and skills to proactively intervene and prevent life-threatening situations.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "3AD5495F-0186-F111-99B9-005056A77B46",
                "course_category_name": "Lifebeat Solutions - Rescue Readiness Series - Curriculum",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "5BB700E2-6271-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "Recognizing and Responding to Deteriorating Patients",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module covers the most common and costly failures in nursing surveillance\u2014failing to recognize signs of deterioration, delaying action, and miscommunicating urgency. This course trains nurses to detect changes early, act decisively, and escalate concerns clearly.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses describe the impact of Failure to Rescue on patient outcomes and identify the nursing surveillance gaps that contribute to it.</li>\r\n    <li>Nurses identify the critical pillars of prevention used to recognize early signs of patient deterioration.</li>\r\n    <li>Nurses differentiate Failure to Act from missed nursing care and explain how each contributes to preventable harm.</li>\r\n    <li>Nurses apply structured communication strategies to prevent Failure to Communicate during patient deterioration.</li>\r\n</ul>",
                "course_outline_html": "<h3>Recognizing and Responding to Deteriorating Patients</h3>\r\n<p>This course introduces foundational concepts in recognizing patient deterioration and responding effectively to prevent failure to rescue events.</p>\r\n<strong>Lessons:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Failure to Rescue Overview</li>\r\n    <li>Failure to Recognize: Critical Pillars of Prevention Overview</li>\r\n    <li>Failure to Act: Missed Nursing Care</li>\r\n    <li>Failure to Communicate</li>\r\n</ul>\r\n<strong>Criteria for Completion:</strong>\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Complete all lessons</li>\r\n    <li>Pass end-of-module assessment (if applicable)</li>\r\n    <li>Review case-based scenarios on patient deterioration</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "08B48896-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Rescue Readiness Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B78FE06E-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Rescue Readiness Series",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3800DF92-6A71-F111-99AF-005056A7F5E9",
                "course_version": 2,
                "name": "The Nurses' Critical Role in Failure to Rescue (FTR)",
                "course_type": 1,
                "author_information": "Julie Siemers, DNP, MSN, RN",
                "description": "This module breaks down the 8 major nursing errors that lead to preventable harm, exploring the balance of clinical reasoning and clinical judgment. It frames the nurse as the last line of defense and offers strategies to fulfill that role reliably.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul style=\"list-style-type:disc;\">\r\n    <li>Nurses distinguish between nursing errors of commission and errors of omission and their impact on patient safety.</li>\r\n    <li>Nurses identify the 8 major nursing errors that lead to practice breakdown as defined by the NCSBN.</li>\r\n    <li>Nurses explain how adherence to nursing standards of care reduces the risk of preventable harm.</li>\r\n    <li>Nurses differentiate analytical and intuitive clinical reasoning in the context of patient assessment.</li>\r\n    <li>Nurses apply clinical judgment principles to optimize patient outcomes in ambiguous clinical situations.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                        "course_category_name": "Medical Surgical",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                        "course_category_name": "Critical Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Acute Care Facility",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "4D43C161-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                        "course_category_name": "Quality Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                        "course_category_name": "Patient Safety",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FEC6E955-D5C9-E511-82AF-005056B150D3",
                        "course_category_name": "Risk Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                        "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                        "course_category_name": "Course",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                        "course_category_name": "New Graduate Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "08B48896-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Rescue Readiness Series [Manage Subscribers with Content Package]",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                        "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                        "course_category_name": "Clinical Educator",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B3A99091-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nursing Instructor and Teacher, Postsecondary",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "014B7B43-B797-EB11-80DE-005056B160AF",
                        "course_category_name": "Patient Monitoring",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B78FE06E-B070-F111-99B5-005056A7013F",
                        "course_category_name": "Lifebeat Solutions: Rescue Readiness Series",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "",
                    "course_level_accreditation_statement": "\"Lifebeat Solutions is approved as a provider by the California Board of Registered Nursing&nbsp; (Provider #17984) and the Florida Board of Nursing (CEP #50-40782). The following state nursing boards may accept credits approved in these states.&nbsp; It is the responsbiliy of the learner to check with their state specific licensing board: Alabama, Alaska, Arkansas, California, Delaware, Florida, Georgia, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Massachusetts, Michigan, Minnesota, Mississippi, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, North Carolina, North Dakota, Ohio, Pennsylvania, Rhode Island, South Carolina, Tennessee, Texas, Utah, Virginia, Washington, West Virginia, Wyoming.&rdquo;",
                    "credit_display_name": "CNE",
                    "credit_units": 1.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];